var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderGreadientMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 417 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H417V268H0V0Z",
    fill: "url(#paint0_linear_1543_4163)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_4163",
    x1: 208.5,
    y1: -37.5,
    x2: 208.5,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136913,
    stopColor: "#000039",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968623,
    stopColor: "#000039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderGreadientMob);
export default __webpack_public_path__ + "static/media/Header_greadient_mob.bcd122bcac942e3583bc43c5aeb16429.svg";
export { ForwardRef as ReactComponent };